
import { get, post, postChange } from './index'
import axios from 'axios'

// 列表
export const defaultShowApi = params => {
  return get('/api/config_management/default_show/list', params)
}
// 系统列表（下拉框）
export const systemListApi = () => {
  return get('/api/common/system_list')
}
// 菜单（下拉框）
export const menuListApi = params => {
  return get('/api/config_management/default_show/menu_list', params)
}
// 添加
export const add =(params)=> {
  return post('/api/config_management/default_show/create',params)
}
// 删除
export const del =(params)=> {
  return post('/api/config_management/default_show/del',params)
}
// 导入
export const Imports =(params)=> {
  // return post('/api/config_management/default_show/import',params)
  return axios.post('/api/config_management/default_show/import', params)
}
// 导出
// export const Exports = params => {
//   let str = qs.stringify(params)
//   console.log(str)
//   return get('/api/config_management/default_show/export?' + str)
// }
// 日志
export const log =(params)=> {
  return get('/api/config_management/default_show/log?id='+params.id+"&page="+params.page)
}
// 获取名字
export const  getUsername =(params)=> {
  return get('/api/config_management/default_show/get_username', params)
}
export const editGet =(params)=> {
  return get('/api/config_management/default_show/detail', params)
}
export const editPost =(params)=> {
  return post('/api/config_management/default_show/edit', params)
} 



// 导入
// export const ImportApi = function(params){
//   return axios.post('/api/scrap_application/import', params)
// }



